import { ReportParametersDTO } from '../../../Domain/DTO/ReportParametersDTO';
import { IChartData } from './IChart';

export class ReportParametersExtendedDTO extends ReportParametersDTO{
    Data: IChartData;
}